import { Flex, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  title: string;
  subtitle: string;
};

export function ChatEmptyState({ title, subtitle }: Props) {
  return (
    <Flex direction="column" align="center" justify="center" h="100%" px="xl">
      <Text size="textSm" fw={FONT_WEIGHTS.medium} c="gray.7">
        {title}
      </Text>
      <Text size="textXl" fw={FONT_WEIGHTS.medium} c="gray.7" ta="center" mt="xxs">
        {subtitle}
      </Text>
    </Flex>
  );
}
